import React, { useState } from "react";
import VegIcon from "../../Assets/vegIcon.png";
import NonVegIcon from "../../Assets/nonVegIcon.png";
import Vegan from "../../Assets/vegan.png";
import Egg from "../../Assets/egg.png";
import Checkbox from "../Checkbox";
import "./DietFilter.scss";

const DietFilter = ({ dietSelect }) => {
  const [selected, setSelected] = useState([]);

  const handleDietChange = (foodTypeId) => {
    const nextSelected = selected.includes(foodTypeId)
      ? selected.filter((id) => id !== foodTypeId)
      : [...selected, foodTypeId];

    setSelected(nextSelected);
    dietSelect(nextSelected);
  };

  return (
    <div className="filter-row">
      <Checkbox checked={selected.includes(1)} onChange={() => handleDietChange(1)}>
        <img src={VegIcon} alt="" /> Veg
      </Checkbox>
      <Checkbox checked={selected.includes(2)} onChange={() => handleDietChange(2)}>
        <img src={NonVegIcon} alt="" /> Non-veg
      </Checkbox>
      <Checkbox checked={selected.includes(3)} onChange={() => handleDietChange(3)}>
        <img src={Vegan} alt="" /> Vegan
      </Checkbox>
      <Checkbox checked={selected.includes(4)} onChange={() => handleDietChange(4)}>
        <img src={Egg} alt="" /> Egg
      </Checkbox>
    </div>
  );
};

export default DietFilter;
